import type { BaseElement } from 'slate';

import type { AlineContentBlock, SuggestedEdit, SuggestedHeadersEdit } from '../../internal';

export enum HeaderType {
  Default = 'default-header',
  Even = 'even-header',
  FirstPage = 'first-page-header',
}

export interface BaseHeaderElement extends BaseElement {
  children: AlineContentBlock[];
  type: HeaderType;
  suggestedEdits?: SuggestedEdit[] | null;
}
export interface DefaultHeaderElement extends BaseHeaderElement {
  type: HeaderType.Default;
}
export interface FirstPageHeaderElement extends BaseHeaderElement {
  type: HeaderType.FirstPage;
}
export interface EvenHeaderElement extends BaseHeaderElement {
  type: HeaderType.Even;
}
export type HeaderElement = DefaultHeaderElement | FirstPageHeaderElement | EvenHeaderElement;

export type HeadersType = 'headers';
export const headersType: HeadersType = 'headers';
export interface HeadersElement extends BaseElement {
  // Margin from the top of the page *in inches*.
  children: HeaderElement[];
  headerMargin: number;
  type: HeadersType;
  suggestedEdits?: SuggestedHeadersEdit[] | null;
}

export type HeadersElementProps = Omit<HeadersElement, 'children'>;
